import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  TestID: Yup.string().required("Required"),
  ResultOutcomes: Yup.string()
    .matches(/^[a-zA-Z0-9\s]+$/, "Incorrect format")
    .min(0, "Cannot be empty")
    .max(700, "Must be 700 characters or less")
    .required("Required"),
  ReleaseDate: Yup.date().required("Required").typeError("Invalid Date!"),
  ResultsDocuments: Yup.array().of(
    Yup.object().shape({
      URI: Yup.string().trim().required("Required"),
      Description: Yup.string()
        .matches(/^[a-zA-Z0-9\s]+$/, "Incorrect format")
        .min(0, "Cannot be empty")
        .max(700, "Must be 700 characters or less").required("Required"),
    })
  ),
});

export const ReceiptsValidationSchema = Yup.object().shape({
  patient_id: Yup.string().required('Patient is required'),
  amount: Yup.number()
    .typeError('Amount must be a number')
    .positive('Amount must be a positive number')
    .required('Amount is required'),
  currency: Yup.string().required('Currency is required'),
});
